<template>
  <div class="toast-container" id="toast-container">
    <div
      v-for="t in toasts"
      :id="'toast-' + t.id"
      :key="t.id"
      class="toast"
      :class="t.type"
    >{{ t.message }}</div>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'
const { toasts } = useToast()
</script>
